
import { httpBus } from "@/api/index.js";

/**
 * 修改储能单元
 * @returns 
 */
export function updateUnit(unit) {
  return httpBus.request("put", `/device/unit`, { data: unit });
}


/**
 * 新增储能单元
 * @returns 
 */
export function addUnit(unit) {
  return httpBus.request("post", `/device/unit`, { data: unit });
}


/**
 * 获取储能单元列表
 * @returns 
 */
export function getUnitList(pageNum, pageSize, stationId) {
  return httpBus.request("get", `/device/unit/list`, {
    params: {
      pageNum,
      pageSize,
      stationId
    }
  });
}

/**
 * 批量删除储能单元
 * @returns 
 */
export function delUnitList(mainUnitIds) {
  return httpBus.request("delete", `/device/unit/${mainUnitIds}`);
}

/**
 * 获取储能单元详细信息
 * @returns 
 */
export function getUnit(mainUnitId) {
  return httpBus.request("get", `/device/unit/${mainUnitId}`);
}


